import PropTypes from "prop-types";

const FrameComponent2 = ({ className = "" }) => {
  return (
    <section
      className={`flex-1 flex flex-col items-start gap-1.5 min-w-[426px] max-w-full text-left text-[40px] text-[#000] font-[Manrope] mq750:min-w-full ${className}`}
    >
      <div className="self-stretch flex items-start py-0 pl-80 pr-[92px] text-center text-[#fff] font-['Great_Vibes'] mq750:pl-40 mq750:pr-[46px] mq750:box-border mq450:pl-5 mq450:pr-5 mq450:box-border">
        <div className="flex-1 rounded-[10px] bg-[#1e1e1e] flex items-start pt-2.5 pb-[23px] pl-7 pr-[21px]">
          <div className="h-[104px] w-[244px] relative rounded-[10px] bg-[#1e1e1e] hidden shrink-0" />
          <div className="flex-1 relative z-[1] shrink-0 mq750:text-[32px] mq450:text-2xl">
            <span>Insta</span>
            <span className="text-[64px] font-black font-['Kumbh_Sans']">
              ED
            </span>
          </div>
        </div>
      </div>
      <div className="self-stretch flex items-start pt-0 pb-[140px] pl-[327px] pr-[94px] text-2xl font-['Maven_Pro'] mq750:pl-[163px] mq750:pr-[47px] mq750:box-border mq450:pl-5 mq450:pr-5 mq450:box-border">
        <h3 className="m-0 relative text-[length:inherit] font-normal font-[inherit] mq450:text-[19px]">
          Online Tuitions | 6-12
        </h3>
      </div>
      <div className="flex flex-col items-start pt-0 px-0 pb-[43px] box-border gap-[22.9px] max-w-full text-4xl text-schemes-primary">
        <div className="h-12 relative font-extrabold inline-block mq750:text-[29px] mq450:text-[22px]">
          <span>Feels like</span>
          <span className="text-5xl">{` `}</span>
          <span className="text-[64px]">Classroom.</span>
        </div>
        <div className="h-[47px] relative font-extrabold inline-block max-w-full z-[1] mq750:text-[29px] mq450:text-[22px]">
          <span>Works</span>
          <span className="text-[40px]">{` `}</span>
          <span className="text-[64px]">Better.</span>
        </div>
      </div>
      <div className="self-stretch flex items-start pt-0 px-0 pb-[34px] box-border max-w-full text-[32px]">
        <div className="flex-1 relative inline-block max-w-full mq750:text-[26px] mq450:text-[19px]">
          The online class as good as offline.
          <br />
          Learn from the comfort of your home. <br />
          No travel. No extra expenses. More secured.
        </div>
      </div>
      <div className="w-[492px] flex items-start justify-center py-0 px-5 box-border max-w-full">
        <div className="flex flex-col items-end gap-8">
          <div className="flex items-start gap-4">
            <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
            <button className="cursor-pointer [border:none] p-0 bg-[#353434] h-[25px] w-[25px] relative rounded-[50%]" />
            <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
            <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
            <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
            <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
          </div>
          <div className="flex items-start justify-end py-0 pl-6 pr-[23px]">
            <button className="cursor-pointer border-[#948d8d] border-solid border-[1px] pt-3.5 pb-4 pl-[29px] pr-6 bg-[#fff] h-[67px] rounded-[5px] box-border flex items-start hover:bg-[#e6e6e6] hover:border-[#7a7373] hover:border-solid hover:hover:border-[1px] hover:box-border">
              <div className="h-[67px] w-[183px] relative rounded-[5px] bg-[#fff] border-[#948d8d] border-solid border-[1px] box-border hidden shrink-0" />
              <div className="relative text-2xl font-[Manrope] text-[#000] text-left z-[1] shrink-0">
                Get Started
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

FrameComponent2.propTypes = {
  className: PropTypes.string,
};

export default FrameComponent2;
